import { clsx } from 'clsx';
import React from 'react';

import type {
  ByfunnFrapiArticle,
  ByfunnPromoArticle,
} from '../../../../../types/frapi-types.js';

import { LinkWithPulse } from '../../../../../../core/mandatory-integrations/pulse/components/LinkWithPulse.js';
import { formatRestaurantUrl } from '../../helpers.js';

type UrlButtonsProps = {
  article: ByfunnFrapiArticle | ByfunnPromoArticle;
  compact?: boolean;
  renderRuterButton?: boolean;
};

const UrlButtons: React.FC<UrlButtonsProps> = ({
  article,
  compact = false,
  renderRuterButton = false,
}: UrlButtonsProps) => (
  <div className="url-buttons">
    {renderRuterButton && article.ruterUrl && (
      <div
        className="ruter-button-container"
        data-pulse-entity-id="ruter-button"
      >
        <span className="ruter-ad-label">Annonse</span>
        <LinkWithPulse
          id="ruter-button"
          name="click ruter button"
          className="button ruter"
          href={article.ruterUrl}
          ariaLabel={`${compact ? 'Åpne reiserute til restauranten i Ruter Reiseplanlegger' : ''}`}
          target="_blank"
          rel="noreferrer"
        >
          Finn reise
        </LinkWithPulse>
      </div>
    )}

    {article.restaurant_url && (
      <LinkWithPulse
        id="website-button"
        name="click website button"
        className={clsx('button', 'homepage', { condensed: compact })}
        href={formatRestaurantUrl(article.restaurant_url)}
        ariaLabel={`${compact ? 'Gå til restaurantens nettside' : ''}`}
        target="_blank"
        rel="noreferrer"
      >
        {!compact && 'Nettside'}
      </LinkWithPulse>
    )}

    {article.googleMapsLink && (
      <LinkWithPulse
        id="google-maps-button"
        name="click google maps button"
        className={clsx('button', 'map', { condensed: compact })}
        href={article.googleMapsLink}
        ariaLabel={`${compact ? 'Åpne restauranten i Google Maps' : ''}`}
        target="_blank"
        rel="noreferrer"
      >
        {!compact && 'Kart'}
      </LinkWithPulse>
    )}
  </div>
);

export default UrlButtons;
